// src/i18n/en/options.ts
// «Opciones del hotel» and «Opciones de Roommatik» — mockup 13, tabs 2 and 3.
export const options = {
  toast: {
    saved: 'Saved successfully',
    saveError: 'Could not save. Please try again.',
  },

  hotel: {
    tabLabel: 'Hotel options',
    selectHotel: 'Property',
    sections: {
      stuck: 'Stuck thresholds (minutes)',
      general: 'General',
      wall: 'Wall screen',
      devices: 'Devices',
    },
    fields: {
      stuckS: 'Reservation search (S)',
      stuckR: 'Room selection (R)',
      stuckI: 'Identification (I)',
      stuckF: 'Signature (F)',
      stuckU: 'Extras (U)',
      stuckP: 'Payment (P)',
      stuckK: 'Key delivery (K)',
      onlineThresholdsDoubled: 'Double the thresholds for online pre-check-in',
      chargesOnline: 'The property charges during online pre-check-in',
      durationBuckets: 'Duration buckets',
      wallTheme: 'Screen theme',
      wallContent: 'Screen content',
      wallFooterCounters: 'Show counters in the footer',
      showAirLobbyStaff: 'Show staff in Air Lobby',
      silentDeviceHours: 'Hours of inactivity before alerting',
      deviceNames: 'Device names',
    },
    durationBucketsOptions: {
      standard: 'Standard',
      fastKiosk: 'Fast kiosk',
    },
    wallThemeOptions: {
      dark: 'Dark',
      light: 'Light',
    },
    wallContentOptions: {
      full: 'Full',
      liveOnly: 'Live only',
    },
    applyToGroup: 'Apply to every hotel in the group',
    applyToGroupConfirm: 'Apply this configuration to every hotel in the group? Their current settings will be overwritten.',
    help: {
      title: 'Hotel options',
      description: 'Stuck thresholds, the wall screen and other parameters specific to this property.',
      features: {
        thresholds: 'Each step of the process (language, data, identification…) has its own minute threshold before it is flagged as stuck.',
        applyToGroup: 'A GroupAdmin can copy this configuration to every hotel in the group at once.',
      },
    },
  },

  roommatik: {
    tabLabel: 'Roommatik options',
    selectGroup: 'Group',
    fields: {
      nameRetentionDays: 'Guest name retention (days)',
      viewerCanExport: 'The Viewer role can export',
    },
    help: {
      title: 'Roommatik options',
      description: 'Group-wide parameters: how long the guest name is kept and whether the Viewer role can export.',
      features: {
        retention: 'This many days after departure, the guest name is cleared from reservations.',
      },
    },
  },
};

export default options;
